import { createElement, setText, getUiRoot } from './dom';
import type { ErrorModal } from './types';

export function createErrorModal(): ErrorModal {
  function show(title: string, lines: readonly string[]): void {
    const root = getUiRoot();

    const overlay = createElement('div', 'modal-overlay', root);
    const content = createElement('div', 'modal-content', overlay);

    const titleEl = createElement('h2', 'modal-title modal-error', content);
    setText(titleEl, title);

    const body = createElement('div', 'modal-body', content);

    if (lines.length > 0) {
      const details = createElement('div', 'modal-error-details', body);
      setText(details, lines.join('\n'));
    }

    const closeBtn = createElement('button', 'modal-close', content);
    setText(closeBtn, 'Close');

    closeBtn.addEventListener('click', () => {
      overlay.remove();
    });
  }

  return { show };
}
